import { useParams } from 'react-router-dom'
import { useCurrentShow } from '@/context/current-show'

export function useShowSlug(): string | undefined {
  const params = useParams<{ showSlug?: string }>()
  const { currentShow } = useCurrentShow()
  const currentSlug = currentShow?.slug
  return params.showSlug?.trim() || currentSlug || undefined
}
